import * as React from "react";
type Props = {
  className?: string,
};
function SvgCalorieConscious({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-CalorieConscious"
      className={className}
    >
      <path
        d="M29.8695 3V20.5978M35.1487 15.5313L29.8979 21.317L24.5899 15.4681M23.0786 25.6838C23.0786 31.8799 19.0481 36 13.0072 36C7.5965 36 4 32.8193 4 28.0474C4 23.8285 5.41859 22.7681 5.41859 20.1396C5.41859 19.4993 5.3312 19.0018 5.3312 18.5716C5.3312 17.8533 5.75495 17.4339 6.38521 17.4339C7.28681 17.4339 8.7588 18.0634 9.47574 19.5541C10.4452 17.4339 7.32653 14.3759 6.90059 13.8554C6.62912 13.524 6.46601 13.1263 6.46601 12.7508C6.46601 11.7784 7.3244 11.2485 8.59569 11.2485C14.4735 11.2485 23.0786 15.5121 23.0786 25.6838Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgCalorieConscious;
